export default "__VITE_ASSET__hsJjOSzx__"